// extracted by mini-css-extract-plugin
export default {"reactSlidedown":"slideUpDown_reactSlidedown__RvhmU","transitioning":"slideUpDown_transitioning__vY911","closed":"slideUpDown_closed__9I7mB"};